function importAll(r) {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const images = importAll(require.context('./', false, /\.(png|jpe?g|svg)$/));

const imageArray = Object.values(images);

export default imageArray;
